/**
 * TempoSupply – Cloudlift LPO bootstrap (safe / minimal).
 * 1) Ensure "quantity" extension flag so tier rows render.
 * 2) German labels for Mengenrabatt (Buy:/Save: → Ab / − %).
 * 3) Bundle units use "Sets", singles use "Stück".
 * No MutationObserver / DOM sync — that previously froze the shop.
 */
(function () {
  'use strict';

  var BUNDLE_HANDLE_RE =
    /bundle|farb-trio|all-in-one-duftpaket|6er-set|sparpaket/i;

  function ensureQuantityExtension(cfg) {
    if (!cfg || typeof cfg !== 'object') return;

    var parts = (cfg.extensions || '')
      .split(',')
      .map(function (part) {
        return part.trim().toLowerCase();
      })
      .filter(Boolean);

    if (parts.indexOf('quantity') === -1) {
      parts.push('quantity');
      cfg.extensions = parts.join(',');
    }
  }

  function isBlank(value) {
    return value == null || String(value).trim() === '';
  }

  function collectHandles(node, out) {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) {
      node.forEach(function (item) {
        collectHandles(item, out);
      });
      return;
    }
    if (typeof node.handle === 'string') out.push(node.handle);
    Object.keys(node).forEach(function (key) {
      collectHandles(node[key], out);
    });
  }

  function entryIsBundle(entry) {
    var handles = [];
    collectHandles(entry, handles);
    if (!handles.length) return false;
    var sleepyOrBundle = handles.filter(function (handle) {
      return /sleepy|bundle|trio|set/i.test(handle);
    });
    if (!sleepyOrBundle.length) return false;
    return sleepyOrBundle.every(function (handle) {
      return BUNDLE_HANDLE_RE.test(handle);
    });
  }

  function germanizeQuantityOption(option, isBundle) {
    if (!option || option.type !== 'quantity-discount') return;

    if (!option.params) option.params = {};
    var params = option.params;

    if (isBlank(params.textDiscountBuy) || params.textDiscountBuy === 'Buy:') {
      params.textDiscountBuy = 'Ab';
    }

    if (
      isBlank(params.textDiscountSave) ||
      params.textDiscountSave === 'Save:' ||
      params.textDiscountSave === 'Rabatt:'
    ) {
      params.textDiscountSave = '−';
    }

    params.unitQuantity = isBundle ? '\u00a0Sets' : '\u00a0Stück';

    if (isBlank(params.quantitySuffix) || params.quantitySuffix === '+') {
      params.quantitySuffix = '\u200b';
    }

    // Gesamtpreis + Compare + Rabatt behalten; Stück-/Set-Preis zusätzlich
    // in der Lücke vor dem Spar-Badge ({priceP} = productFinal pro Einheit).
    var per = isBundle ? '/&nbsp;Set' : '/&nbsp;Stück';
    params.discountTemplate =
      '{price} {compare}<span class="_unit-price">{priceP}<span class="_per">' +
      per +
      '</span></span> {discount}';

    if (option.label === 'Mengenrabatte' || isBlank(option.label)) {
      option.label = 'Mengenrabatt';
    }
  }

  function germanizeConfigs(cfg) {
    if (!cfg || !cfg.configs) return;
    cfg.configs.forEach(function (entry) {
      var options = (entry && entry.options) || [];
      if (!Array.isArray(options)) return;
      var bundle = entryIsBundle(entry);
      options.forEach(function (option) {
        germanizeQuantityOption(option, bundle);
      });
    });
  }

  function patchOptions(value) {
    if (!value || typeof value !== 'object') return;
    if (value.config) {
      ensureQuantityExtension(value.config);
      germanizeConfigs(value.config);
    }
  }

  window.Cloudlift = window.Cloudlift || {};
  var storedOptions = window.Cloudlift.options;

  Object.defineProperty(window.Cloudlift, 'options', {
    configurable: true,
    enumerable: true,
    get: function () {
      return storedOptions;
    },
    set: function (value) {
      storedOptions = value;
      patchOptions(value);
    }
  });

  if (storedOptions) {
    window.Cloudlift.options = storedOptions;
  }
})();
